export default __webpack_public_path__ + "static/media/category-9.67a82629.svg";